import { APP_BASE_PATH } from '../../../../common/constants'

const TITLE = 'FAQs | Freedom Debt Relief'
const DESCRIPTION =
  'Browse our FAQs to learn about how Freedom Debt Relief works, debt relief fees, how to find a legit debt relief company, and more.'
const URL = `${APP_BASE_PATH()}`

export const faqData = {
  seo: {
    title: TITLE,
    description: DESCRIPTION,
    canonical: URL,
    openGraph: {
      title: TITLE,
      description: DESCRIPTION,
      url: URL,
      locale: 'en_US',
      type: 'article',
      article: {
        modifiedTime: '2020-05-12T17:01:10+00:00',
        authors: ['https://www.facebook.com/freedomdebtrelief'],
      },
      images: [
        {
          url: `${APP_BASE_PATH()}/next-assets/brand-pages/heros/faq.webp`,
        },
      ],
    },
  },
  seeMore: 'See all debt relief FAQs',
}

const faqsUnsorted = [
  // Question 2
  {
    title: 'What services does Freedom Debt Relief provide to reduce debt?',
    content: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Freedom Debt Relief offers professional debt relief services. We negotiate with creditors, on behalf of our clients, to accept less than the full amount owed and forgive the rest.',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Compare your debt relief options with a free debt evaluation',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'We understand that your debt situation is unique and needs a solution built just for you to best fit your needs. That’s why we offer a ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://apply.freedomdebtrelief.com/home?from=fdr&leadId=45e00590-17bc-4176-8e03-0539867c716d&visit_id=ae5db331-af31-4ffb-9ba4-534e6a8d935b&estimated_debt=25000',
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'free debt evaluation',
                  marks: [
                    {
                      type: 'underline',
                    },
                  ],
                  data: {},
                },
              ],
            },
            {
              nodeType: 'text',
              value:
                ' that looks at all your available options so you have a clear path to get rid of debt. We’ll help you find the best fit with us or one of our partners.',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Debt expert and legal support',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'We have a team of Certified Debt Consultants, Debt Negotiators, and Client Services Reps to help you along your debt-free journey. We also offer access to the Legal Partner Network for additional debt negotiation support should you need it.',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '\nSee more information about ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.freedomdebtrelief.com/why-were-better/',
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'why clients choose us',
                  marks: [
                    {
                      type: 'underline',
                    },
                  ],
                  data: {},
                },
              ],
            },
            {
              nodeType: 'text',
              value: ' to help them put debt behind them. ',
              marks: [],
              data: {},
            },
          ],
        },
      ],
    },
  },
  // Question 4
  {
    title: 'How does a debt relief program like Freedom Debt Relief work?',
    content: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Freedom Debt Relief offers a smart way to help you pay less on debt in as little as 24-48 months. ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '1. In our debt relief program, you’ll make one low monthly deposit into your Dedicated Account, and these deposits will be used to fund settlements to your creditors. ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '2. Once enough funds are built up in your Dedicated Account, our expert team negotiates with your creditors to settle debt for less than you owe.',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '3. When we reach a settlement, we send the offer to you to approve. Once approved, payments are sent to your creditor from your Dedicated Account to resolve your debt.',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '\n',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value:
                'Freedom Debt Relief will also process our program fee at this time.',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: '\n',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: 'Learn more about ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.freedomdebtrelief.com/how-it-works/',
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'how debt relief works',
                  marks: [
                    {
                      type: 'underline',
                    },
                  ],
                  data: {},
                },
              ],
            },
            {
              nodeType: 'text',
              value: ' to help you get rid of debt. ',
              marks: [],
              data: {},
            },
          ],
        },
      ],
    },
  },
  // Question 6
  {
    title: 'What type of debt can I enroll in a debt relief program?',
    content: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Our debt resolution program could help you with unsecured debts (debt not backed by collateral like a house or car). ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Debts we could help with ',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '• ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.freedomdebtrelief.com/credit-card-debt/',
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Credit card or retail store cards',
                  marks: [
                    {
                      type: 'underline',
                    },
                  ],
                  data: {},
                },
              ],
            },
            {
              nodeType: 'text',
              value: ' ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '• ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.freedomdebtrelief.com/debt-relief/medical-debt-relief/',
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Medical debt',
                  marks: [{ type: 'underline' }],
                  data: {},
                },
              ],
            },
            {
              nodeType: 'text',
              value: ' ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '• Most personal loans ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '• Collections or repossessions ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '• Lines of credit ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '• Some payday loans ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '• ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.freedomdebtrelief.com/debt-relief/private-student-loan-debt-relief/',
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Some private student loans',
                  marks: [{ type: 'underline' }],
                  data: {},
                },
              ],
            },
            {
              nodeType: 'text',
              value: ' ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Debts we can’t help with',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: ' ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '• Taxes ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '• Utility bills ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '• Lawsuits ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '• Secured loans (HELOC, auto, etc.) ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '• Federal student loans ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Still not sure if your debt is eligible for Freedom Debt Relief? We’ll help you figure it out : Call 800-910-0065.',
              marks: [],
              data: {},
            },
          ],
        },
      ],
    },
  },
  // Question 1
  {
    title: 'Why should I trust Freedom Debt Relief?',
    content: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'As a trusted leader in debt relief, we’ve served over 1 million clients and settled more than $20 billion in debt since 2002. Our credibility is backed by industry certifications, positive client reviews, and recognition from leading publications.',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Industry-certified & trusted',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Freedom Debt Relief is held to the highest standards in the industry through our affiliations with respected professional organizations:',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Association for Consumer Debt Relief (ACDR) - As a founding member, we follow best practices for ethical and effective debt settlement.',
                      marks: [],
                      data: {},
                    },
                  ],
                },
              ],
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'International Association of Professional Debt Arbitrators (IAPDA) - As a platinum member, our team is certified in ethical debt settlement practices and works with more than 4,500 creditors nationwide.',
                      marks: [],
                      data: {},
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Reviewed and rated—by people just like you',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'No matter where you are on your journey with debt, we’ll always put your needs first.',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'But don’t take our word for it—thousands of real customers give us top marks:',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Best Company - 4.8/5 (19,500+ reviews)',
                      marks: [],
                      data: {},
                    },
                  ],
                },
              ],
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Trustpilot - 4.6/5 (50,000+ reviews)',
                      marks: [],
                      data: {},
                    },
                  ],
                },
              ],
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Google -  4.6/5 (8,300+ reviews)',
                      marks: [],
                      data: {},
                    },
                  ],
                },
              ],
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'ConsumerAffairs - 4.5/5 (34,000+ reviews)',
                      marks: [],
                      data: {},
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.freedomdebtrelief.com/reviews/',
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Check out the Freedom Debt Relief reviews.',
                  marks: [
                    {
                      type: 'underline',
                    },
                  ],
                  data: {},
                },
              ],
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Media recognition & awards',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'We’ve been recognized by top publications and review platforms for our excellence, outstanding service, and trusted results.',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Ranked the #1 debt relief provider by ',
                      marks: [],
                      data: {},
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://www.latimes.com/b2b/business-partnerships/story/2025-06-12/best-debt-relief-companies-2025',
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'the Los Angeles Times ',
                          marks: [
                            {
                              type: 'underline',
                            },
                          ],
                          data: {},
                        },
                      ],
                    },
                    {
                      nodeType: 'text',
                      value: '(2025)',
                      marks: [],
                      data: {},
                    },
                  ],
                },
              ],
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'ConsumerAffairs - Debt Settlement (2026) - Best Overall',
                      marks: [],
                      data: {},
                    },
                  ],
                },
              ],
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'A+ rating on Better Business Bureau',
                      marks: [],
                      data: {},
                    },
                  ],
                },
              ],
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Featured in ',
                      marks: [],
                      data: {},
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://www.cbsnews.com/news/which-type-of-debt-relief-could-save-you-the-most-now-experts/',
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'CBS News,',
                          marks: [
                            {
                              type: 'underline',
                            },
                          ],
                          data: {},
                        },
                      ],
                    },
                    {
                      nodeType: 'text',
                      value: ' ',
                      marks: [],
                      data: {},
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://money.usnews.com/money/personal-finance/debt-settlement/articles/the-truth-about-credit-card-debt-forgiveness',
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'U.S. News & World Report,',
                          marks: [
                            {
                              type: 'underline',
                            },
                          ],
                          data: {},
                        },
                      ],
                    },
                    {
                      nodeType: 'text',
                      value: ' ',
                      marks: [],
                      data: {},
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://www.businessinsider.com/personal-finance/credit-score/freedom-debt-relief-review',
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Business Insider,',
                          marks: [
                            {
                              type: 'underline',
                            },
                          ],
                          data: {},
                        },
                      ],
                    },
                    {
                      nodeType: 'text',
                      value: ' and ',
                      marks: [],
                      data: {},
                    },
                    {
                      nodeType: 'hyperlink',
                      data: {
                        uri: 'https://www.kiplinger.com/personal-finance/talking-about-money-still-taboo',
                      },
                      content: [
                        {
                          nodeType: 'text',
                          value: 'Kilinger',
                          marks: [
                            {
                              type: 'underline',
                            },
                          ],
                          data: {},
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  },
  // Question 5
  {
    title: 'Is debt relief an affordable option and can I qualify?',
    content: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'A debt relief program can be a good option as you could resolve your debt for less than you owe and in less time than making minimum payments. ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Easy to get started. ',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: 'Unlike a consolidation loan or personal loan, ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: 'you don’t need good credit to qualify',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value:
                ' for Freedom Debt Relief. There are no upfront settlement fees to enroll in the program.',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Get a ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://apply.freedomdebtrelief.com/home/states?leadId=45e00590-17bc-4176-8e03-0539867c716d&from=fdr&visit_id=ae5db331-af31-4ffb-9ba4-534e6a8d935b&estimated_debt=25000&campaign=home',
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'free debt evaluation',
                  marks: [
                    {
                      type: 'bold',
                    },
                    {
                      type: 'underline',
                    },
                  ],
                  data: {},
                },
              ],
            },
            {
              nodeType: 'text',
              value:
                '. A Certified Debt Consultant can help you go through your options, from debt consolidation or personal loans to credit counseling and more. ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Choose a plan that fits your budget. ',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value:
                'Once you enroll your debts into the program, you could get a plan to move on from debt with one low monthly payment. ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Only pay us when we deliver results. ',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'We’re confident we could help you to succeed in reducing debt for less than you owe. That’s why we offer a money-back program guarantee⁴. And we only charge settlement fees after you approve your settlement and the first payment has been made.',
              marks: [],
              data: {},
            },
          ],
        },
      ],
    },
  },
  // Question 3
  {
    title: 'Does Freedom Debt Relief offer debt consolidation loans?',
    content: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'No, Freedom Debt Relief does not offer debt consolidation loans.',
              marks: [],
              data: {},
            },
          ],
        },
      ],
    },
  },
  // Question 7
  {
    title: 'Does Freedom Debt Relief still exist?',
    content: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Yes. Freedom Debt Relief remains an active debt relief company and consumer program.',
              marks: [],
              data: {},
            },
          ],
        },
      ],
    },
  },
  // Question 8
  {
    title: 'Is Freedom Debt Relief part of Achieve?',
    content: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Freedom Debt Relief and Achieve are related organizations, but Freedom Debt Relief continues operating as its own active consumer-facing debt relief brand.',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Learn more about ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.freedomdebtrelief.com/about/freedom-debt-relief-and-achieve/',
              },
              content: [
                {
                  nodeType: 'text',
                  value:
                    'the relationship between Freedom Debt Relief and Achieve',
                  marks: [{ type: 'underline' }],
                  data: {},
                },
              ],
            },
            {
              nodeType: 'text',
              value: '.',
              marks: [],
              data: {},
            },
          ],
        },
      ],
    },
  },
  // Question 9
  {
    title: 'How to login to the Freedom Debt Relief client dashboard?',
    content: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Freedom Debt Relief customers should continue logging in through the FreedomDebtRelief.com home page by clicking the ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.freedomdebtrelief.com/login?showLogin=true',
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'Client Dashboard',
                  marks: [{ type: 'underline' }],
                  data: {},
                },
              ],
            },
            {
              nodeType: 'text',
              value: ' login button in the upper right top navigation.',
              marks: [],
              data: {},
            },
          ],
        },
      ],
    },
  },
]

const faqOrder = [
  'What services does Freedom Debt Relief provide to reduce debt?',
  'How does a debt relief program like Freedom Debt Relief work?',
  'What type of debt can I enroll in a debt relief program?',
  'Why should I trust Freedom Debt Relief?',
  'Is debt relief an affordable option and can I qualify?',
  'Does Freedom Debt Relief offer debt consolidation loans?',
  'Does Freedom Debt Relief still exist?',
  'Is Freedom Debt Relief part of Achieve?',
  'How to login to the Freedom Debt Relief client dashboard?',
]

export const faqs = [...faqsUnsorted].sort(
  (left, right) => faqOrder.indexOf(left.title) - faqOrder.indexOf(right.title)
)

export const SpanishfaqData = {
  seo: {
    title: 'Preguntas Frecuentes | Freedom Debt Relief',
    description:
      'Consulta nuestras preguntas frecuentes para saber cómo funciona Freedom Debt Relief, las tarifas de alivio de deuda, cómo encontrar una empresa legítima de alivio de deuda y más',
    canonical: URL,
    openGraph: {
      title: 'Preguntas Frecuentes | Freedom Debt Relief',
      description:
        'Consulta nuestras preguntas frecuentes para saber cómo funciona Freedom Debt Relief, las tarifas de alivio de deuda, cómo encontrar una empresa legítima de alivio de deuda y más',
      url: URL,
      locale: 'en_US',
      type: 'article',
      article: {
        modifiedTime: '2020-05-12T17:01:10+00:00',
        authors: ['https://www.facebook.com/freedomdebtrelief'],
      },
      images: [
        {
          url: `${APP_BASE_PATH()}/next-assets/brand-pages/heros/faq.webp`,
        },
      ],
    },
  },
  seeMore: 'Ver todas las preguntas frecuentes sobre el alivio de deudas',
}

export const SpanishFaqs = [
  // Question 1
  {
    title: '¿Puedo confiar en Freedom Debt Relief?',
    content: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Como líder de confianza en la liquidación de deudas en los Estados Unidos, estamos orgullosos de ayudar a los estadounidenses como usted a deshacerse de la deuda y reemprender sus vidas. Desde 2002, Freedom Debt Relief ha prestado servicios a más de 1 millón de estadounidenses y ha liquidado más de $20,000 millones en deuda. ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Reconocido y certificado por la industria',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Líder de ACDR. ',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value:
                'Como miembro de la Asociación Americana para la Resolución de Deudas (Association for Consumer Debt Relief, ACDR), Freedom Debt Relief cumple con los más altos estándares en la industria de liquidación de deudas. ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Certificado por la Asociación Internacional de Árbitros Profesionales de Deuda (International Association of Professional Debt Arbitrators, IADPA). ',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value:
                'Somos miembros platino de la Asociación Internacional de Árbitros Profesionales de Deuda (International Association of Professional Debt Arbitrators, IAPDA) y nuestro equipo certificado trabaja con más de 3,500 acreedores.',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'No se limite a aceptar nuestra palabra. Explore las opiniones de nuestros clientes',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Estamos más orgullosos cuando nuestros clientes comparten su experiencia con Freedom Debt Relief y cómo los hemos ayudado con su deuda. Hemos ganado reconocimiento y premios a través de nuestro excelente servicio al cliente y compromiso con la transparencia. Lea más ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.freedomdebtrelief.com/testimonials/',
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'opiniones y testimonios de los clientes',
                  marks: [
                    {
                      type: 'underline',
                    },
                  ],
                  data: {},
                },
              ],
            },
            {
              nodeType: 'text',
              value: '. \n',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'unordered-list',
          data: {},
          content: [
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Consumer Affairs: calificación promedio de 4.5/5, basada en más de 32,000 reseñas',
                      marks: [],
                      data: {},
                    },
                  ],
                },
                {
                  nodeType: 'unordered-list',
                  data: {},
                  content: [
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Mejor experiencia con el personal - Debt Settlement (2024) - ConsumerAffairs',
                              marks: [],
                              data: {},
                            },
                          ],
                        },
                      ],
                    },
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Mejor servicio al cliente - Debt Settlement (2024) - ConsumerAffairs',
                              marks: [],
                              data: {},
                            },
                          ],
                        },
                      ],
                    },
                    {
                      nodeType: 'list-item',
                      data: {},
                      content: [
                        {
                          nodeType: 'paragraph',
                          data: {},
                          content: [
                            {
                              nodeType: 'text',
                              value:
                                'Lo mejor para la transparencia - Debt Settlement (2024) - Asuntos del consumidor',
                              marks: [],
                              data: {},
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Calificación de TrustPilot de 4.6/5, basada en más de 43,000 reseñas',
                      marks: [],
                      data: {},
                    },
                  ],
                },
              ],
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Mejor calificación de la compañía de 4.8/5, basada en más de 17,000 reseñas',
                      marks: [],
                      data: {},
                    },
                  ],
                },
              ],
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value: 'Calificación A+ en Better Business Bureau',
                      marks: [],
                      data: {},
                    },
                  ],
                },
              ],
            },
            {
              nodeType: 'list-item',
              data: {},
              content: [
                {
                  nodeType: 'paragraph',
                  data: {},
                  content: [
                    {
                      nodeType: 'text',
                      value:
                        'Destacado en Yahoo! Finance, USA Today, MSN, Motley Fool, CNBC',
                      marks: [],
                      data: {},
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {},
            },
          ],
        },
      ],
    },
  },
  // Question 2
  {
    title: '¿Qué servicios proporciona?',
    content: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Freedom Debt Relief y nuestras afiliadas ofrecen soluciones integrales de deuda, desde alivio de deudas hasta préstamos personales y consolidación de deudas, que se personalizan para reducir su deuda de una manera que se adapte a su presupuesto y objetivos. ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Compare sus opciones de alivio de deuda con una evaluación de deuda gratuita',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Comprendemos que su situación de deuda es única y necesita una solución creada para que usted se adapte mejor a sus necesidades. Por ese motivo, ofrecemos una evaluación de deuda gratuita que analiza todas sus opciones disponibles para que tenga una dirección clara sobre cómo deshacerse de las deudas. Le ayudaremos a encontrar la mejor opción con nosotros o con uno de nuestros socios.',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Experto en deudas y apoyo legal',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Contamos con un equipo de consultores certificados en deuda, negociadores de deuda y representantes de servicios al cliente para ayudarle a lo largo de su camino hacia la liberación de deudas. También ofrecemos acceso a la Red de socios legales para obtener apoyo adicional en la negociación de deudas en caso de que lo necesite.',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '\nVea más información acerca de ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.freedomdebtrelief.com/why-were-better/',
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'por qué los clientes nos eligen',
                  marks: [
                    {
                      type: 'underline',
                    },
                  ],
                  data: {},
                },
              ],
            },
            {
              nodeType: 'text',
              value: ' para ayudarles a superar las deudas. ',
              marks: [],
              data: {},
            },
          ],
        },
      ],
    },
  },
  // Question 3
  {
    title: '¿Freedom Debt Relief ofrece préstamos de consolidación de deuda?',
    content: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Sí, Freedom Debt Relief tiene socios afiliados que podrían ofrecer ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.freedomdebtrelief.com/debtconsolidation/',
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'préstamos de consolidación de deuda',
                  marks: [],
                  data: {},
                },
              ],
            },
            {
              nodeType: 'text',
              value:
                '. Los préstamos tienden a tener mayores requisitos de crédito, y un programa de alivio de deudas tiene diferencias clave y ofrece varias ventajas sobre la consolidación de deudas a través de un préstamo. ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Más fácil de calificar que un préstamo.',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value:
                ' Puede haber requisitos de crédito más altos para calificar para una consolidación de deuda o préstamo personal. No necesita un buen crédito para inscribirse en Freedom Debt Relief. ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Reduce lo que debe.',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value:
                ' Un programa de alivio de deudas podría ayudarle a pagar menos sobre su deuda total a diferencia de un préstamo de consolidación.',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Sin intereses adicionales.',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value:
                ' Dado que un programa de alivio de deudas no implica un préstamo, usted no paga intereses a Freedom Debt Relief como lo haría con un préstamo. ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '¿Todavía está interesado en un préstamo para consolidar su deuda? Puede obtener una calificación previa a través de Freedom Debt Relief. Nuestra filial de préstamos asociada puede comprobar si reúne los requisitos para una consolidación de deudas o un préstamo personal o si existen opciones que se ajusten mejor a sus necesidades. ',
              marks: [],
              data: {},
            },
          ],
        },
      ],
    },
  },
  // Question 4
  {
    title:
      '¿Cómo funciona un programa de alivio de deuda como Freedom Debt Relief?',
    content: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Freedom Debt Relief ofrece una manera inteligente de ayudarle a pagar menos de su deuda en tan solo 24 a 48 meses. ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '1. En nuestro programa de alivio de deudas, realizará un depósito mensual en su Cuenta Dedicada y estos depósitos se utilizarán para financiar liquidaciones a sus acreedores. ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '2. Una vez que se acumulen los fondos suficientes en su Cuenta Dedicada, nuestro equipo de expertos negocia con sus acreedores para liquidar sus deudas por menos de lo que usted adeuda.',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '3. Cuando llegamos a un acuerdo, le enviamos la oferta para que la apruebe. Una vez aprobada, los pagos se envían a su acreedor desde su Cuenta Dedicada para resolver su deuda. Freedom Debt Relief también procesará nuestro cargo del programa en este momento.',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Obtenga más información sobre ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'hyperlink',
              data: {
                uri: 'https://www.freedomdebtrelief.com/how-it-works/',
              },
              content: [
                {
                  nodeType: 'text',
                  value: 'cómo funciona el alivio de la deuda',
                  marks: [
                    {
                      type: 'underline',
                    },
                  ],
                  data: {},
                },
              ],
            },
            {
              nodeType: 'text',
              value: ' para ayudarle a liberarse de sus deudas. ',
              marks: [],
              data: {},
            },
          ],
        },
      ],
    },
  },
  // Question 5
  {
    title: '¿El alivio de la deuda es una opción asequible y puedo calificar?',
    content: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Un programa de alivio de la deuda puede ser una buena opción, ya que podría resolver su deuda por menos de lo que debe y en menos tiempo que haciendo pagos mínimos. ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Es fácil comenzar. ',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value:
                'A diferencia de un préstamo de consolidación o un préstamo personal, ',
              marks: [],
              data: {},
            },
            {
              nodeType: 'text',
              value: 'no necesita un buen crédito para calificar',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value:
                ' para Freedom Debt Relief. No hay cargos por adelantado para inscribirse en el programa.',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Obtenga una evaluación de deuda gratuita. ',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value:
                'Un asesor de deuda certificado puede ayudarle a analizar sus opciones, desde consolidación de deudas o préstamos personales hasta asesoramiento crediticio y mucho más. ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Elija un plan que se ajuste a su presupuesto. ',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value:
                'Una vez que inscriba sus deudas en el programa, podría obtener un plan para salir de la deuda con un pago mensual bajo. ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Solo nos paga cuando vea resultados. ',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Estamos seguros de que podríamos ayudarle a tener éxito en la reducción de deudas por menos de lo que debe. Por eso, ofrecemos una garantía de devolución del dinero**. Y solo cobramos los cargos de liquidación después de que usted apruebe su liquidación y se haya efectuado el primer pago.',
              marks: [],
              data: {},
            },
          ],
        },
      ],
    },
  },
  // Question 6
  {
    title:
      '¿Qué tipo de deuda puedo inscribir en un programa de reducción de deuda?',
    content: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                'Nuestro programa de resolución de deudas podría ayudarle con deudas no garantizadas (deudas no respaldadas por una garantía, como una casa o un automóvil). ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Deudas con las que podríamos ayudar ',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '- Tarjetas de crédito o de tiendas minoristas ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '- Deuda médica ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '- La mayoría de los préstamos personales ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '- Cobros o embargos ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '- Líneas de crédito ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '- Algunos préstamos de nómina ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '- Algunos préstamos estudiantiles privados ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Deudas con las que no podemos ayudar',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: ' ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '- Impuestos ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '- Facturas de servicios públicos ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '- Demandas ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '- Préstamos garantizados (HELOC, automóvil, etc.) ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '- Préstamos federales para estudiantes ',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: '',
              marks: [],
              data: {},
            },
          ],
        },
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value:
                '¿Todavía no está seguro de si su deuda es elegible para Freedom Debt Relief? Le ayudaremos a averiguarlo: Llame al 800-910-0065.',
              marks: [],
              data: {},
            },
          ],
        },
      ],
    },
  },
]
